import React from "react";

import {
  Box,
  IconToolTip,
  Span,
  Text,
  Tooltip,
} from "@catchoftheday/cg-components";

import { Discount } from "../../ProductCard/productCardTypes";
import { CountdownTimer } from "../CountdownTimer";

type ProductPriceLabelProps = {
  discount?: Discount;
  topLabel?: string | null;
  enabled: boolean;
  large?: boolean;
  retailPriceDisclaimer?: string;
};

export const ProductPriceLabel = ({
  discount,
  enabled,
  topLabel,
  large,
  retailPriceDisclaimer,
}: ProductPriceLabelProps) => {
  if (!topLabel && !discount) {
    return null;
  }

  if (topLabel) {
    return (
      <Span
        display="inline-block"
        fontSize={large ? "0.9rem" : "xs"}
        fontWeight="semibold"
        verticalAlign="middle"
        color={enabled ? "typography.text" : "typography.inactive"}
      >
        {topLabel}
        {large && retailPriceDisclaimer && (
          <Tooltip
            ml="5px"
            reference={
              <IconToolTip
                aria-label="Price disclaimer"
                tabIndex={0}
                width="12px"
                height="12px"
                mb="2px"
                color="typography.subText"
              />
            }
            placement="top"
          >
            <Text m="0" fontSize="xs">
              {retailPriceDisclaimer}
            </Text>
          </Tooltip>
        )}
      </Span>
    );
  }

  let date;
  if (discount?.endDate) {
    date = new Date(discount.endDate);
  }

  const timerProps = { date, maxHoursShown: 2, timerLabel: "Ends" };

  return (
    <Box display="block">
      <Box textTransform="uppercase" lineHeight={0}>
        {discount?.label && (
          <Span
            display="inline-block"
            fontSize={large ? "0.9rem" : "xs"}
            fontWeight="semibold"
            color={enabled ? "primary" : "typography.inactive"}
          >
            {discount.label}&nbsp;
          </Span>
        )}
        {date && (
          <Span
            display="inline-block"
            color={enabled ? "error" : "typography.inactive"}
            fontSize={large ? "0.9rem" : "xs"}
            fontWeight="semibold"
          >
            <CountdownTimer {...timerProps} />
          </Span>
        )}
        {discount?.percentageLabel && (
          <Span
            display="inline-block"
            color={enabled ? "error" : "typography.inactive"}
            fontSize={large ? "0.9rem" : "xs"}
            fontWeight="semibold"
          >
            {discount.percentageLabel}
          </Span>
        )}
      </Box>
    </Box>
  );
};
